/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getApiOrganizationContextResponse = zod.object({
  "organizationId": zod.string().uuid().nullish()
})

export const putApiOrganizationContextBody = zod.object({
  "organizationId": zod.string().uuid()
})

export const getOrganizationContextCapabilitiesResponse = zod.object({
  "canBulkApprovePayoutRequests": zod.boolean(),
  "canViewBatchProcesses": zod.boolean(),
  "canVoidPayout": zod.boolean(),
  "canPayPayoutsNow": zod.boolean(),
  "canViewFunding": zod.boolean(),
  "canSetTalentPushToCard": zod.boolean(),
  "canAssignTalentPayoutPolicy": zod.boolean(),
  "canListTalentReferrals": zod.boolean(),
  "canElectReceivableEarlyDisbursement": zod.boolean(),
  "canViewProviderReferences": zod.boolean(),
  "canUseSensitiveDevTools": zod.boolean()
})

